import { createAction } from "typesafe-actions";
import { BookOfTheMonthActionTypes } from "./book-of-the-month-types";
import { IProduct } from "~/types/product";
import { IProductDetailsProps } from "~/components/product-details/product-details";

export interface ISkipBookOfTheMonthRequest extends Pick<IProduct, "productId"> {
    skipBookOfTheMonthWebApiUrl: string;
}

export interface ISkipBookOfTheMonthSuccess
    extends Pick<IProduct, "bookOfTheMonthStatusLabel">,
        Pick<IProductDetailsProps, "isSkipBookOfTheMonthAllowed"> {}

export const skipBookOfTheMonthRequest = createAction(
    BookOfTheMonthActionTypes.SKIP_BOTM_REQUEST,
    resolve => {
        return (request: ISkipBookOfTheMonthRequest) => resolve(request);
    }
);
export const skipBookOfTheMonthSuccess = createAction(
    BookOfTheMonthActionTypes.SKIP_BOTM_SUCCESS,
    resolve => {
        return (response: ISkipBookOfTheMonthSuccess) => resolve(response);
    }
);
export const skipBookOfTheMonthError = createAction(BookOfTheMonthActionTypes.SKIP_BOTM_ERROR);
